import { Component, OnInit } from "@angular/core";
import { AppService } from "../services/app.service";
import { SupportService } from "../services/support-service";
import { Location } from "@angular/common";
import { FormControl } from "@angular/forms";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";

@Component({
  selector: "app-imaging",
  templateUrl: "./imaging.component.html",
})
export class ImagingComponent implements OnInit {
  rowsData = [
    { title: "Imaging Center", sorting: true, name: "tcName", underline: true },
    { title: "Address", tooltip: true },
    { title: "City" },
    { title: "State" },
    { title: "Country" },
    { title: "Zip Code" },
  ];

  columnsData = [];
  columnsRes = [];
  p = 1;
  totalItems: any;
  currentPage = 1;
  page: number;
  maxSize = 10;
  maxSizeItem = 30;
  firstNameControl = new FormControl();
  formCtrlSub: Subscription;
  searchPatient = "";
  sortColumn = "createdOn";
  orderColumn = "desc";
  searchText = "";
  alphaVal = "all";
  routerName = "";
  maxSizeItemValue: any;
  address: any = "";
  startDate = "";
  endDate = "";
  countryData = [];
  stateData = [];
  countryidadmin: any = "";
  stateidadmin: any = "";
  country: any = "";
  selectedCountry: any = "";
  selectedState: any = "";
  constructor(
    private appService: AppService,
    private supportService: SupportService,
    private location: Location,
    private router: Router
  ) {}

  ngOnInit() {
    this.getAllCountry();
    sessionStorage.setItem("page", "dashboardic");
    if (
      sessionStorage.getItem("startDate") &&
      sessionStorage.getItem("endDate")
    ) {
      this.startDate = sessionStorage.getItem("startDate");
      this.endDate = sessionStorage.getItem("endDate");
    } else {
      this.startDate = "";
      this.endDate = "";
    }
    this.getAllTCListAdmin("");

    this.supportService.gridSortingHeader.subscribe((res) => {
      if (res && res["length"] !== 0 && res["routerName"] === this.routerName) {
        this.sortColumn = res["name"];
        this.orderColumn = res["order"];
        const event = {
          page: 1,
        };
        this.currentPage = 1;
        this.getAllTCListAdmin(event);
      }
    });
    this.checkUrl();
  }
  getAllCountry() {
    this.appService.getCountry().subscribe((res) => {
      if (res && res["status"] && res["status"]["status"] === 200) {
        this.countryData = res["entity"];
      } else {
        this.countryData = [];
      }
    });
  }

  getAllStateByCountry(countryid) {
    this.appService.getState(countryid).subscribe((res) => {
      if (res && res["status"] && res["status"]["status"] === 200) {
        this.stateData = res["entity"];
      } else {
        this.stateData = [];
      }
    });
  }

  onChangeState(event) {
    sessionStorage.setItem("stateidadmin", this.selectedState.id);
    this.stateidadmin = sessionStorage.getItem("stateidadmin");
    this.getAllTCListAdmin("");
  }

  onChange(event) {
    sessionStorage.setItem("countryidadmin", this.selectedCountry.id);
    this.countryidadmin = sessionStorage.getItem("countryidadmin");
    this.stateidadmin = "";
    this.getAllStateByCountry(event.id);
    this.selectedState = "";
    this.getAllTCListAdmin("");
  }

  navigateToDashboard() {
    this.router.navigate([
      localStorage.getItem("testCode").toString().trim(),
      "dashboard",
    ]);
  }

  checkUrl() {
    const path = this.location.path().split("/");
    if (path.length === 3) {
      this.routerName = path[2];
    }
  }

  onBlurSearchMethod() {
    this.searchPatient = this.searchText;
    this.currentPage = 1;
    this.getAllTCListAdmin("");
  }

  refreshPatient() {
    this.searchText = "";
    this.searchPatient = "";
    this.selectedCountry = "";
    this.selectedState = "";
    this.stateidadmin = "";
    this.countryidadmin = "";
    this.getAllTCListAdmin("");
  }

  alphaSearch(val) {
    if (val !== "all") {
      this.searchPatient = val;
    } else {
      this.searchPatient = "";
    }
    this.alphaVal = val;
    this.searchText = "";
    this.getAllTCListAdmin("");
  }

  getAllTCListAdmin(event) {
    let data;
    if (event) {
      data = {
        pageNumber: event.page,
        pageRecord: this.maxSizeItem,
        startDate: this.startDate,
        endDate: this.endDate,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        search: this.searchPatient,
        countryid: this.countryidadmin,
        stateid: this.stateidadmin,
      };
    } else {
      data = {
        pageNumber: 1,
        pageRecord: this.maxSizeItem,
        startDate: this.startDate,
        endDate: this.endDate,
        sortColumn: this.sortColumn,
        sortType: this.orderColumn,
        search: this.searchPatient,
        countryid: this.countryidadmin,
        stateid: this.stateidadmin,
      };
    }

    this.appService.getAllTCListAdminWithFilter(data).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"]) {
            this.columnsData = [];
            this.columnsRes = res["entity"];
            this.columnsRes.forEach((obj) => {
              this.columnsData = this.columnsData.concat({
                param1: obj.tcName ? obj.tcName : "-",
                param2:
                  obj.addressLine1 && obj.addressLine2
                    ? obj.addressLine1 + ", " + obj.addressLine2
                    : obj.addressLine1 && !obj.addressLine2
                    ? obj.addressLine1
                    : !obj.addressLine1 && obj.addressLine2
                    ? obj.addressLine2
                    : "-",
                param3: obj.cityName ? obj.cityName : "-",
                param4: obj.stateName ? obj.stateName : "-",
                param5: obj.countryName ? obj.countryName : "-",
                param6: obj.zip_code ? obj.zip_code : "-",
                param7: obj.testcenterId ? obj.testcenterId : "-",
                param8: this.routerName ? this.routerName : "-",
                param13: "Double click for edit",
              });
            });
            this.totalItems = res["count"];
          }
        } else {
          this.columnsData = [];
          this.totalItems = 0;
        }
      },
      (err) => {
        this.appService.sessionOut(err);
      }
    );
  }

  pageChanged(event: any): void {
    this.page = event.page;
    this.getAllTCListAdmin(event);
  }
}
